exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".modal-d83f3>div>button>span{display:flex;justify-content:center;align-items:center}.positionsTable-8aa8d{background-color:#fff;box-shadow:0 0 3px #ccc;border-radius:4px}", ""]);

// Exports
exports.locals = {
	"modal": "modal-d83f3",
	"positionsTable": "positionsTable-8aa8d"
};